<script setup lang="ts">
import { ShieldCheck } from 'lucide-vue-next'

// Savings at 20% a year: 300 000 som earns 5 000 som a month, 60 000 som in 12 months
const { t } = useI18n()

const months = Array.from({ length: 12 }, (_, index) => index + 1)

const barClass = (month: number) => {
  if (month === 12) return 'bg-yellow-400'
  if (month > 8) return 'bg-blue-600'
  if (month > 4) return 'bg-blue-500'

  return 'bg-blue-300'
}

const barHeight = ['h-[5%]', 'h-[10%]', 'h-[15%]', 'h-[20%]', 'h-[25%]', 'h-[30%]', 'h-[35%]', 'h-[40%]', 'h-[45%]', 'h-1/2', 'h-[55%]', 'h-3/5']
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="HeroIllustrationCard">
      <div class="flex items-end justify-between">
        <div>
          <div class="text-sm text-gray-500">{{ t('widget.hero_banner.illustration.deposits.in_a_year') }}</div>
          <div class="font-serif text-2xl font-bold">360 000 {{ t('widget.hero_banner.illustration.som') }}</div>
        </div>
        <div class="text-right text-sm text-gray-500">
          {{ t('widget.hero_banner.illustration.deposits.invested') }}
          <div class="font-semibold">300 000 {{ t('widget.hero_banner.illustration.som') }}</div>
        </div>
      </div>

      <div class="mt-4 flex h-28 items-end gap-1.5">
        <div v-for="month in months" :key="month" class="flex h-full flex-1 flex-col justify-end">
          <div class="rounded-t-[3px]" :class="[barClass(month), barHeight[month - 1]]" />
          <div class="h-2/5 bg-blue-100" />
        </div>
      </div>
      <div class="mt-2 flex justify-between text-xs text-gray-400">
        <span>{{ t('widget.hero_banner.illustration.deposits.month_1') }}</span>
        <span>{{ t('widget.hero_banner.illustration.deposits.month_6') }}</span>
        <span>{{ t('widget.hero_banner.illustration.deposits.month_12') }}</span>
      </div>
    </div>

    <div class="HeroIllustrationSticker -right-6 -top-5">
      <div class="text-xs font-semibold">{{ t('widget.hero_banner.illustration.deposits.income') }}</div>
      <div class="text-lg font-bold leading-none">+60 000</div>
    </div>

    <div class="HeroIllustrationBadge -bottom-4 -left-8">
      <ShieldCheck class="size-4 text-green-400" />
      {{ t('widget.hero_banner.illustration.deposits.insured') }}
    </div>
  </div>
</template>
